import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../../services/api'

// React Query-hooks voor het support-ticketsysteem (gebruikerskant).
// Query key: ['support', 'tickets'].

export function useSupportTickets() {
  return useQuery({
    queryKey: ['support', 'tickets'],
    queryFn: async () => (await api.get('/support/tickets')).data,
  })
}

// payload = FormData (multipart/form-data): titel, beschrijving, type, module,
// email + optioneel screenshot (File) en screenshot_thumbnail (base64-string).
// axios zet de multipart-boundary automatisch op basis van het FormData-object.
export function useMaakTicket() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (formData) => (await api.post('/support/tickets', formData)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['support', 'tickets'] }),
  })
}

// Laadt de in DB bewaarde thumbnail (auth-vereist) als object-URL, on-demand.
// Een kale <img src> kan de JWT niet meesturen, vandaar de blob-fetch via axios.
export function useTicketThumbnail(ticketId, enabled = false) {
  return useQuery({
    queryKey: ['support', 'thumbnail', ticketId],
    enabled: !!enabled && !!ticketId,
    staleTime: Infinity,
    gcTime: 5 * 60 * 1000,
    queryFn: async () => {
      const res = await api.get(`/support/tickets/${ticketId}/thumbnail`, { responseType: 'blob' })
      return URL.createObjectURL(res.data)
    },
  })
}
